import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if this.icon}}\n  {{d-icon this.icon}}\n{{/if}}\n{{yield}}",{ moduleName: "discourse/components/tap-tile.hbs" })